import { cn } from '@/lib/cn';

/**
 * ONE LOOK FOR EVERY ROW IN THE SIDEBAR (Glass 2, DESIGN.md §16.5 punkt 12).
 *
 * The menu, a festival and its pages, and a venue and its pages were three copies of the same
 * class string; they now read it from here, so «valgt menypunkt har aksentfyll og aksenttekst»
 * is one rule and not three that drift.
 *
 * Rows are full-strength text with a muted icon, as in the reference; the selected row takes the
 * accent fill and the accent text, icon included, so where you are is visible at a glance in any
 * of the three accents.
 */
export const NAV_ROW = 'h-[var(--row-height-compact)]';

export const NAV_ROW_LINK = cn(
  'group flex items-center gap-2 rounded-[var(--radius-menu-row)] text-sm text-default ring-focus',
  'transition-colors duration-[var(--duration-fast)]',
  'hover:bg-[var(--fill-tonal)]',
  'data-[status=active]:bg-[var(--nav-selected-bg)] data-[status=active]:font-semibold',
  'data-[status=active]:text-[color:var(--nav-selected-text)]',
);

/** The icon in a row: muted at rest, the accent text when the row is where you are. */
export const NAV_ROW_ICON =
  'size-4 shrink-0 text-muted group-data-[status=active]:text-[color:var(--nav-selected-text)]';

/** A section heading in the sidebar: sentence case, as the reference writes it. */
export const NAV_SECTION_HEADING = 'text-xs font-semibold text-muted';

/** A small square control inside a row (expand/collapse, «+»). */
export const NAV_ROW_BUTTON = cn(
  'flex shrink-0 items-center justify-center rounded-[var(--radius-menu-row)] text-muted ring-focus',
  'transition-colors duration-[var(--duration-fast)]',
  'hover:bg-[var(--fill-tonal)] hover:text-default',
);
